import axios from 'axios'
import serverUrl from '@/assets/BaseServerUrl.js'

const userService = {
  async lookupUserIdByUsername(username) {
    const res = await axios.get(`${serverUrl}/api/user/lookup`, { params: { username } })
    return res.data
  },
  async lookupUsernameByUserId(userId) {
    const res = await axios.get(`${serverUrl}/api/user/lookup-by-id`, { params: { userId } })
    return res.data
  }
}

export default userService
